module.exports = __webpack_public_path__ + "static/media/logo-sofradom-white.eb445b6d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/logo-sofradom-white.png
// module id = 221
// module chunks = 0